module.exports = __webpack_public_path__ + "static/gdpmdlong-d286a83560b4c3478ca2f13d77d0b613.png";